const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export const rp = (n) => `Rp${Math.round(Number(n) || 0).toLocaleString("id-ID")}`;
export const KATEGORI = { gold: "Gold", platinum: "Platinum" };
export const katLabel = (k) => KATEGORI[k] || "Belum diatur";
export const num = (n) => (Number(n) || 0).toLocaleString("id-ID");

export const fmtDate = (iso) =>
  iso ? new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const periodOf = (iso) => `${iso.slice(0, 7)}-${Number(iso.slice(8, 10)) <= 15 ? 1 : 2}`;
export const currentPeriod = () => periodOf(todayISO());

export const shiftPeriod = (key, delta) => {
  const [y, m, h] = key.split("-").map(Number);
  const idx = (y * 12 + (m - 1)) * 2 + (h - 1) + delta;
  const ny = Math.floor(idx / 24);
  const r = idx % 24;
  return `${ny}-${String(Math.floor(r / 2) + 1).padStart(2, "0")}-${(r % 2) + 1}`;
};

export const periodLabel = (key) => {
  const [y, m, h] = key.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return h === 1 ? `1–15 ${BULAN[m - 1]} ${y}` : `16–${last} ${BULAN[m - 1]} ${y}`;
};

export const waPhone = (hp) => {
  const d = (hp || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("0")) return `62${d.slice(1)}`;
  return d;
};
